import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const SupplierService = {
  // Define your API functions here
  getPaymentList: async ({
    supplierId,
    startDate,
    endDate,
    paymentType,
    purchaseId,
    page = 1,
    pageSize = 10,
  } = {}) => {
    const params = new URLSearchParams({
      Page: page.toString(),
      PageSize: pageSize.toString(  ),
      ...(supplierId && { SupplierId: supplierId }),
      ...(startDate && { StartDate: startDate }),
      ...(endDate && { EndDate: endDate }),
      ...(paymentType && { PaymentTypeId: paymentType }),
      ...(purchaseId && { PurchaseId: purchaseId }),
    });
    const response = await apiService.get(
      `/supplierpayments?${params}`,
      {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get("/suppliers", {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  create: async (postData) => {
    const response = await apiService.post("/suppliers", postData, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/suppliers/${id}`, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/suppliers/${id}`, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/suppliers/${id}`, updatedData, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  supplierPayment: async (postData) => {
    const response = await apiService.post("/supplierpayments", postData, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
  supplierPaymentList: async ({
    pageNumber = 1,
    perPage = 10,
    SearchText = "",
  } = {}) => {
    const params = new URLSearchParams({
      Page: pageNumber.toString(),
      PageSize: perPage.toString(),
      ...(SearchText && { SearchText: SearchText.toString() }),
    });
    const response = await apiService.get(
      `/supplierpayments?${params.toString()}`,
      {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  getSuppliersPending: async (id) => {
    const response = await apiService.get(
      `/supplierpayments/suppliers-pending?supplierId=${id}`,
      {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  getAllSuppliersPending: async (search = "") => {
    const response = await apiService.get(
      `/supplierpayments/suppliers-pending?search=${search}`,
      {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      },
    );
    return response.data;
  },
  getSupplierBalance: async (id) => {
    const response = await apiService.get(`/supplierpayments/supplier-balance/${id}`, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
  getPendingPurchases: async (id) => {
    const response = await apiService.get(`/supplierpayments/pending-purchases/${id}`, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
};

export default SupplierService;
